import React, { useContext, useState, useRef } from "react";

import { Button, Col, Container, Form, FormFeedback, FormGroup, FormText, Input, Label, Row } from "reactstrap";
import { useFormik } from "formik";
import * as Yup from "yup";
import Flatpickr from 'react-flatpickr';
import 'flatpickr/dist/themes/material_green.css';
import InputMask from "react-input-mask";
import { addInquiry, uploadInquiryFile } from "helpers/UAM/inquiry.helper";
import ToastDialog from "common/ToastDialog";
import { isEmpty } from "lodash";
import { useNavigate } from "react-router-dom";
import { SystemConfigurationContext } from "context/systemConfigContext";
const AddOrEditInquiry = () => {

    const numberInputMask = {
        mask: '999999999999999',
        guide: false,
        showMaskOnHover: false,
        showMaskOnFocus: false,
        allowEmpty: true,
        allowLeadingZeroes: true,
        integerLimit: 10,
        radixPoint: '',
        rightAlign: false,
    }


    const title = "Product Inquiry"
    document.title="Product Inquiry | DMS"
    const ref = useRef()

    const [isBtnLoading, setIsBtnLoading] = useState(false);
    const [toastInfo, setToastInfo] = useState({ showToast: false });
    const { inputMax } = useContext(SystemConfigurationContext)

    const navigate = useNavigate();

    async function handleFormSubmit(values) {
        setIsBtnLoading(true);
        const res = await addInquiry({ productInfo: values.productInfo });
        if (res.status) {
            setToastInfo({ message: res.message, showToast: true, role: "success" });
            navigate("/customer/product-inquiry");
        } else {
            setToastInfo({ message: res.message, showToast: true, role: "error" });
        }
        setIsBtnLoading(false);
    }


    const formikInitialValues = {
        productInfo: [
            {
                'id': 1,
                'productDescription': '',
                'quantity': '',
                'expectedDeliveryDate': '',
                'expectedPrice': '',
                'file': []
            }
        ],
    };


    const formikValidationSchema = Yup.object().shape({
        productInfo: Yup.array().of(
            Yup.object().shape({
                productDescription: Yup.string().required('Product Description is required'),
                quantity: Yup.number().min(0, "Quantity can't be less than zero").required('Quantity is required').typeError("Quantity must be a number").min(1, "Quantity must be greater then 0"),
                expectedDeliveryDate: Yup.string().required('Expected Delivery Date is required'),
                expectedPrice: Yup.string().required('Expected Price is required'),
                file: Yup.array().of(Yup.string().required('File is required'))
            })
        ).required('Required'),
    });

    const formik = useFormik({
        initialValues: formikInitialValues,
        validationSchema: formikValidationSchema,
        onSubmit: (values) => handleFormSubmit(values),
    });



    const handleAddMore = () => {
        const total = formik.values.productInfo.length
        formik.setFieldValue('productInfo', [...formik.values.productInfo, {
            'id': total + 1, 'productDescription': '', 'quantity': '', 'expectedDeliveryDate': '', 'expectedPrice': '',
            'file': []
        }])
    }

    const handleRemoveProduct = (index) => {
        if (formik.values.productInfo.length == 1) return

        let productInfo = [...formik.values.productInfo]
        productInfo.splice(index, 1)
        formik.setFieldValue('productInfo', productInfo)
    }


    const handleFileUpload = async (e, index) => {
        setIsBtnLoading(true);
        const uploadedFile = e.target.files[0];
        if (!uploadedFile) return;

        const size = uploadedFile.size / 1024 / 1024;

        if (size > 2) {
            setToastInfo({ message: "File size must be less than 2 MB", showToast: true, role: "error" });
            setIsBtnLoading(false);
            const fileInput = window.document.querySelector(`#exampleFile-${index}`);
            fileInput.value = "";
            let productInfo = [...formik.values.productInfo]
            productInfo[index].file = [];
            return;
        }

        const fileUploadApiRes = await uploadInquiryFile(uploadedFile);
        if (fileUploadApiRes.status) {
            let productInfo = [...formik.values.productInfo]
            productInfo[index].file = fileUploadApiRes.data
            formik.setFieldValue('productInfo', productInfo)
        } else {
            setToastInfo({ message: fileUploadApiRes.message, showToast: true, role: "error" });
        }
        setIsBtnLoading(false);
    }


    const handleFilePreview = (index) => {
        const url = process.env.REACT_APP_IMAGE_URL;
        window.open(`${url}/${formik.values.productInfo[index].file[0]}`, '_blank');
    }

    const handleCancel = () => {
        navigate("/customer/product-inquiry");
    }


    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>

                    <Col className="col-12">
                        <div className="page-title-box d-sm-flex align-items-center justify-content-between">
                            <h4 className="mb-sm-0 font-size-18 fixed">{title}</h4>
                        </div>
                    </Col>
                    <Form onSubmit={formik.handleSubmit}>
                        <Row>

                            <div className="col-12">
                                <div className="card">
                                    <div className="card-body my-0">
                                        {formik.values.productInfo.map((product, index) => (
                                            <div key={product.id}>
                                                {index !== 0 && (<div style={{ borderBottom: '0.5px solid #e1e4e8' }}>

                                                </div>)}
                                                <Col className={`d-flex align-items-center justify-content-between ${index !== 0 ? 'mt-3 mb-3' : 'mt-1 mb-1'}`}>
                                                    <div>
                                                        {formik?.values?.productInfo?.length > 1 && (<h5>{`Sub-Inquiry: ${index + 1}`}</h5>)}
                                                    </div>
                                                    <div>
                                                        {index != 0 && <span
                                                            className="text-dark font-size-16"
                                                            style={{ cursor: "pointer" }}
                                                            onClick={() => handleRemoveProduct(index)}
                                                        >
                                                            <i className="mdi mdi-delete me-1 text-danger" />
                                                        </span>}
                                                    </div>
                                                </Col>
                                                <Row >
                                                    <Col sm={12} lg={6} xl={6} md={6}>
                                                        <div className="mb-3">
                                                            <Label className="mb-1 required">Product Description</Label>
                                                            <Input
                                                                maxLength={inputMax}
                                                                type="textarea"
                                                                placeholder="Product Description"
                                                                className={`${formik.touched.productInfo?.[index]?.productDescription &&
                                                                    formik.errors.productInfo?.[index]?.productDescription
                                                                    ? "is-invalid"
                                                                    : ""}`}
                                                                name={`productInfo.[${index}].productDescription`}
                                                                id={`productInfo.[${index}].productDescription`}
                                                                value={formik.values?.productInfo[index]?.productDescription}
                                                                onChange={formik.handleChange}
                                                                invalid={formik.touched.productInfo?.[index]?.productDescription && formik.errors.productInfo?.[index]?.productDescription}
                                                            />
                                                            {formik.touched.productInfo?.[index]?.productDescription &&
                                                                formik.errors.productInfo?.[index]?.productDescription && (
                                                                    <FormFeedback>
                                                                        {formik.errors.productInfo?.[index]?.productDescription}
                                                                    </FormFeedback>
                                                                )}
                                                        </div>
                                                    </Col>

                                                    <Col sm={12} lg={6} xl={6} md={6}>
                                                        <div className="mb-3">
                                                            <Label className="mb-1 required">Expected Quantity</Label>
                                                            <Input
                                                                maxLength={inputMax}
                                                                type="text"
                                                                placeholder="Enter Quantity"
                                                                name={`productInfo.[${index}].quantity`}
                                                                id={`productInfo.[${index}].quantity`}
                                                                value={formik.values?.productInfo[index]?.quantity}
                                                                onChange={(e) => {
                                                                    formik.setFieldValue(`productInfo[${index}].quantity`, e.target.value)
                                                                }
                                                                }
                                                                className={`form-control ${formik.touched.productInfo?.[index]?.quantity &&
                                                                    formik.errors.productInfo?.[index]?.quantity
                                                                    ? "is-invalid"
                                                                    : ""}`}
                                                                invalid={formik.touched.productInfo?.[index]?.quantity && formik.errors.productInfo?.[index]?.quantity}
                                                            />
                                                            {formik.touched.productInfo?.[index]?.quantity &&
                                                                formik.errors.productInfo?.[index]?.quantity && (
                                                                    <FormFeedback>
                                                                        {formik.errors.productInfo?.[index]?.quantity}
                                                                    </FormFeedback>
                                                                )}
                                                        </div>
                                                    </Col>

                                                    <Col sm={12} lg={6} xl={6} md={6}>
                                                        <div className="mb-3">
                                                            <Label className="mb-1 required">Expected Delivery Date</Label>
                                                            <Flatpickr
                                                                placeholder="Select Date"
                                                                name={`productInfo.[index].expectedDeliveryDate`}
                                                                id={`productInfo.[index].expectedDeliveryDate`}
                                                                className={`form-control ${formik.touched.productInfo?.[index]?.expectedDeliveryDate &&
                                                                    formik.errors.productInfo?.[index]?.expectedDeliveryDate
                                                                    ? "is-invalid"
                                                                    : ""}`}
                                                                value={formik.values?.productInfo[index]?.expectedDeliveryDate}
                                                                onChange={(date) => {
                                                                    formik.setFieldValue(`productInfo[${index}].expectedDeliveryDate`, date[0])
                                                                }}
                                                                options={{
                                                                    dateFormat: "M d, Y",
                                                                    minDate: new Date(),
                                                                }}
                                                                invalid={formik.touched.productInfo?.[index]?.expectedDeliveryDate && formik.errors.productInfo?.[index]?.expectedDeliveryDate}
                                                            />
                                                            {formik.touched.productInfo?.[index]?.expectedDeliveryDate &&
                                                                formik.errors.productInfo?.[index]?.expectedDeliveryDate && (
                                                                    <FormFeedback>
                                                                        {formik.errors.productInfo?.[index]?.expectedDeliveryDate}
                                                                    </FormFeedback>
                                                                )}
                                                        </div>
                                                    </Col>

                                                    <Col sm={12} lg={6} xl={6} md={6}>
                                                        <div className="mb-3">
                                                            <Label className="mb-1 required">Expected Price Per Unit</Label>
                                                            <InputMask
                                                                mask={numberInputMask.mask}
                                                                maskChar=""
                                                                placeholder="Enter Price"
                                                                name={`productInfo.[index].expectedPrice`}
                                                                id={`productInfo.[index].expectedPrice`}
                                                                value={formik.values?.productInfo[index]?.expectedPrice}
                                                                onChange={(e) => {
                                                                    formik.setFieldValue(`productInfo[${index}].expectedPrice`, e.target.value)
                                                                }
                                                                }
                                                                className={`form-control ${formik.touched.productInfo?.[index]?.expectedPrice &&
                                                                    formik.errors.productInfo?.[index]?.expectedPrice
                                                                    ? "is-invalid"
                                                                    : ""}`}
                                                                invalid={formik.touched.productInfo?.[index]?.expectedPrice && formik.errors.productInfo?.[index]?.expectedPrice}
                                                            />
                                                            {formik.touched.productInfo?.[index]?.expectedPrice &&
                                                                formik.errors.productInfo?.[index]?.expectedPrice && (
                                                                    <FormFeedback>
                                                                        {formik.errors.productInfo?.[index]?.expectedPrice}
                                                                    </FormFeedback>
                                                                )}
                                                        </div>
                                                    </Col>

                                                    <Col sm={12} lg={6} xl={6} md={6}>
                                                        <div className="mb-3">
                                                            <FormGroup>
                                                                <Label className=" mb-1">Upload File</Label>
                                                                <Input accept=".jpg, .jpeg, .png, .gif, .pdf, .doc, .docx, .xls, .xlsx .odt, .ods, .odp, .csv" onChange={(e) => handleFileUpload(e, index)}  type="file" className="d-block" name="file" id={`exampleFile-${index}`} />
                                                                {!isEmpty(formik.values?.productInfo[index]?.file[0]) ? <FormText color="muted">
                                                                    <p className="text-success mt-2 fs-6" onClick={() => handleFilePreview(index)} style={{
                                                                        cursor: "pointer",
                                                                    }}>View</p>
                                                                </FormText> : <FormText color="muted">
                                                                    You can upload files in JPEG, PDF, Excel, and word formats, with a maximum size limit of 2 MB
                                                                </FormText>}
                                                            </FormGroup>

                                                        </div>
                                                    </Col>
                                                </Row>
                                            </div>
                                        ))}

                                        <Row>
                                            <Col sm={12} lg={12} xl={12} md={12}>
                                                <span
                                                    className="text-success"
                                                    style={{ cursor: "pointer" }}
                                                    onClick={() => handleAddMore()}
                                                >
                                                    <i className="mdi mdi-plus me-1" /> Add More
                                                </span>
                                            </Col>
                                        </Row>

                                    </div>
                                </div>
                            </div>


                            {/* /button */}
                            <div className="col-12">
                                <div className="d-flex align-items-center justify-content-end">
                                    <Button outline color="secondary" type="submit" className="w-md mt-3 me-2" onClick={handleCancel}>
                                        Cancel
                                    </Button>
                                    <Button color="success" type="submit" className="w-md mt-3" disabled={isBtnLoading || formik.values.productInfo.length == 0}>
                                        {isBtnLoading && <span className="spinner-border spinner-border-sm mr-1"></span>}
                                        Submit
                                    </Button>


                                </div>
                            </div>
                        </Row>
                    </Form>
                </Container>
            </div>
            <ToastDialog
                message={toastInfo.message || ""}
                showToast={toastInfo.showToast}
                role={toastInfo.role}
                onCloseFn={() => setToastInfo({ showToast: false })}
            ></ToastDialog>
        </React.Fragment>
    )
}

export default AddOrEditInquiry